import { CSSTransition } from 'react-transition-group';

import { SignUpForm } from '@/shared/components/account/signForms/SignUpForm';
import { SuccessScreen } from '@/shared/components/account/signForms/SuccessScreen';

import styles from './SignUpTab.module.scss';
import { SignUpTabProps } from './types';

export const SignUpTab = ({
	active,
	signUpFormSent,
	backToLoginPress,
	setSignUpFormSent,
}: SignUpTabProps) => {
	return (
		<CSSTransition
			in={active}
			timeout={{ enter: 500, exit: 0 }}
			classNames={{
				enter: styles['signUp__transition-enter'],
				enterActive: styles['signUp__transition-enter-active'],
				exit: styles['signUp__transition-exit'],
				exitActive: styles['signUp__transition-exit-active'],
			}}
			unmountOnExit
		>
			<div className={styles.signUp__container}>
				{signUpFormSent ? (
					<SuccessScreen email={signUpFormSent} type="signUp" backToLoginPress={backToLoginPress} />
				) : (
					<SignUpForm setFormSent={setSignUpFormSent} />
				)}
			</div>
		</CSSTransition>
	);
};
